import { DSCheckbox } from '@vr/ds-react'

import { useGeneralContext } from '@/contexts/general.context'

export const Check = ({
  item,
  onClick,
  operator
}: {
  item: any
  onClick: () => void
  operator: any
}) => {
  const { handleSelectItem, setOperator, operator: contextOperator, setSelectItems, selectItems } = useGeneralContext()

  const checked = selectItems.some((i: any) => i.id === item.id)

  return (
    <DSCheckbox
      checked={checked}
      variant='default'
      onChange={e => {
        const isChecked = (e.target as HTMLInputElement).checked
        if (isChecked) {
          setOperator(operator)
          if (contextOperator?.idOperadora !== operator?.idOperadora) {
            setSelectItems([item])
          } else {
            handleSelectItem(item, true)
          }
        } else {
          handleSelectItem(item, false)
        }
      }}
      onClick={onClick}
    />
  )
}
